import { Box, Grid } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectSpendingInsightsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { InsightCard } from 'modules/project_management/components/InsightCard'

export const ProjectDetailsPageSpendingPageInsights = ({
  projectId,
  projectCurrency,
}: {
  projectId: number
  projectCurrency: string
}) => {
  const { data } = useQuery(ProjectManagementProjectSpendingInsightsDocument, {
    variables: { projectId },
  })

  const approvedAmountCents =
    data?.projectManagement.spendingCostsInsightsConnection.edges[0]?.node?.approvedAmountCents ?? 0
  const pendingAmountCents =
    data?.projectManagement.spendingCostsInsightsConnection.edges[0]?.node?.pendingAmountCents ?? 0

  const totalAmountCents = approvedAmountCents + pendingAmountCents

  const currency =
    data?.projectManagement.spendingCostsInsightsConnection.edges[0]?.node?.amountCurrency ??
    projectCurrency

  return (
    <Grid variant="fixed">
      <Box gridColSpan={{ xxs: 12, s: 4 }}>
        <InsightCard.Cost
          title={i18n.t('project_management.insights.spending_tab.total_spending')}
          info={i18n.t('project_management.insights.spending_tab.total_spending_tooltip')}
          totalCost={totalAmountCents}
          currency={currency}
          titleColor="grey1000"
        />
      </Box>
      <Box gridColSpan={{ xxs: 12, s: 4 }}>
        <InsightCard.Cost
          title={i18n.t('project_management.insights.spending_tab.pending')}
          info={i18n.t('project_management.insights.spending_tab.pending_tooltip')}
          totalCost={pendingAmountCents}
          currency={currency}
          titleColor="grey1000"
        />
      </Box>
      <Box gridColSpan={{ xxs: 12, s: 4 }}>
        <InsightCard.Cost
          title={i18n.t('project_management.insights.spending_tab.validated')}
          info={i18n.t('project_management.insights.spending_tab.validated_tooltip')}
          totalCost={approvedAmountCents}
          currency={currency}
          titleColor="grey1000"
        />
      </Box>
    </Grid>
  )
}
